import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Text } from 'pcln-design-system'

const NonSelectableDropdownItem = ({ displayName, Icon }) => (
  <Flex alignItems='center' width={1} m={0} data-testid='non-selectable-dropdown-item'>
    <Icon color='primary' mx={2} title='Non-Selectable City' size={24} />
    <Text py='12px' mr='8px' fontSize={0}>
      {displayName}
    </Text>
  </Flex>
)

NonSelectableDropdownItem.propTypes = {
  displayName: PropTypes.string,
  Icon: PropTypes.node,
}

export default NonSelectableDropdownItem
